import { hasFailedDepositsReportAccess } from '../../../helpers/userCustomData';
import { canAccessTransactionalSmsProviders } from '../../../helpers/adminAccess';

export default function GetPermissions(
  Dealerpermission: any,
  isRootUser:  boolean,
  userData?: any,
) {
	// Example conditions
	const {
		canControlBanks,
		canChangeDepositRequestStatus,
		canChangeCreditLoanStatus,
		canSeeReportCashRequest,
		canSeeReportDepositRequest,
		canChangeCashDeliveryStatus,
		canSeeReportJournal,
		canSeeReportTransactionsLog,
		canSeeReportUserDetails,
		canSeeReportMoneyTransactions,
		canSeeReportOpenPositions,
		canSeeReportOpenHistory,
		canSeeReportCloseHistory,
		canSeeLeadsMobile,
		canSeeReportOrders,
		canSeeReportFinancialStandings,
		canSeeReportLoginHistory,
		canSeeReportOpenRoboOrders,
		canSeeReportCloseRoboOrders,
		canSeeReportCreditLoans,
		canSeeMarginCallScreen,
		canManageLeads,
		canManageClickToCallMapping,
		canControlSmsProvider,
		//others
		// canSendEmail,
		// canSendAnnouncement,
		// canChangeTransactionDate,
		// canDisconnectClient,
		// canDeposit,
		// canWithdraw,
		// canAdjustment,
		// canCreditIn,
		// canCreditOut,
	} = Dealerpermission;
	const OnlyReports: Record<string, boolean> = {
		transactionsReport:
			canSeeReportTransactionsLog === undefined ? false : canSeeReportTransactionsLog,
		moneyTransactionsReport:
			canSeeReportMoneyTransactions === undefined ? false : canSeeReportMoneyTransactions,
		repeatedDeposit: canSeeReportUserDetails === undefined ? false : canSeeReportUserDetails,
		firstDeposit: canSeeReportUserDetails === undefined ? false : canSeeReportUserDetails,
		todaysLiquidateAccount:
			canSeeReportUserDetails === undefined ? false : canSeeReportUserDetails,
		activeAccountsWithFunds:
			canSeeReportUserDetails === undefined ? false : canSeeReportUserDetails,
		semiInactiveAccounts:
			canSeeReportUserDetails === undefined ? false : canSeeReportUserDetails,
		inactiveAccountsWithFunds:
			canSeeReportUserDetails === undefined ? false : canSeeReportUserDetails,
		topXWinners: canSeeReportUserDetails === undefined ? false : canSeeReportUserDetails,
		topXLoosers: canSeeReportUserDetails === undefined ? false : canSeeReportUserDetails,
		accountWithoutMoneyTransaction:
			canSeeReportUserDetails === undefined ? false : canSeeReportUserDetails,
		usersDetailsReport: canSeeReportUserDetails === undefined ? false : canSeeReportUserDetails,
		openPositionsReport:
			canSeeReportOpenPositions === undefined ? false : canSeeReportOpenPositions,
		detailedOpenPositionsReport:
			canSeeReportOpenPositions === undefined ? false : canSeeReportOpenPositions,
		historyReport:
			canSeeReportOpenHistory === undefined || canSeeReportCloseHistory === undefined
				? false
				: canSeeReportOpenHistory || canSeeReportCloseHistory,
		detailedOpenHistoryReport:
			canSeeReportOpenHistory === undefined ? false : canSeeReportOpenHistory,
		detailedCloseHistoryReport:
			canSeeReportCloseHistory === undefined ? false : canSeeReportCloseHistory,
		pendingOrdersReport: canSeeReportOrders === undefined ? false : canSeeReportOrders,
		financialStandingReport:
			canSeeReportFinancialStandings === undefined ? false : canSeeReportFinancialStandings,
		detailedFinancialStandingReport:
			canSeeReportFinancialStandings === undefined ? false : canSeeReportFinancialStandings,
		financialStandingHistoryReport:
			canSeeReportFinancialStandings === undefined ? false : canSeeReportFinancialStandings,
		otpLogsReport: true,
		loginReport: canSeeReportLoginHistory === undefined ? false : canSeeReportLoginHistory,
		roboOrdersHistory:
			canSeeReportOpenRoboOrders === undefined && canSeeReportCloseRoboOrders === undefined
				? false
				: canSeeReportOpenRoboOrders || canSeeReportCloseRoboOrders,
		openRoboOrdersHistory:
			canSeeReportOpenRoboOrders === undefined ? false : canSeeReportOpenRoboOrders,
		closeRoboOrdersHistory:
			canSeeReportCloseRoboOrders === undefined ? false : canSeeReportCloseRoboOrders,
		withdrawRequestsReport:
			canSeeReportCashRequest === undefined ? false : canSeeReportCashRequest,
		loanRequestsReport: canSeeReportCreditLoans === undefined ? false : canSeeReportCreditLoans,
		depositRequestReport:
			canSeeReportDepositRequest === undefined ? false : canSeeReportDepositRequest,
		clientDepositSummaryReport:
			canSeeReportUserDetails === undefined ? false : canSeeReportUserDetails,
		failedDepositsReport: hasFailedDepositsReportAccess(userData?.customData),
		journalReport: canSeeReportJournal === undefined ? false : canSeeReportJournal,
	};
	const conditions: Record<string, boolean> = {
		dashboard: true,
		customer: true,
		clients: true,
		integrations: isRootUser,
		marginCall: canSeeMarginCallScreen === undefined ? false : canSeeMarginCallScreen,
		leads:true,
		allLeads:canSeeLeadsMobile === undefined ? false : canSeeLeadsMobile,
		leadAssignments:canManageLeads === undefined ? false : canManageLeads,
		clickToCall: canManageClickToCallMapping === undefined ? false : canManageClickToCallMapping,
		agentMappings: canManageClickToCallMapping === undefined ? false : canManageClickToCallMapping,
		clickToCallHistory: canManageClickToCallMapping === undefined ? false : canManageClickToCallMapping,
		dealerCallActivityReport:
			canManageClickToCallMapping === undefined ? false : canManageClickToCallMapping,
		analysis: true,
		chartWidget: true,
		economicCalendar: true,
		ticker: true,
		banks: canControlBanks === undefined ? false : canControlBanks,
		withdraw: canChangeCashDeliveryStatus === undefined ? false : canChangeCashDeliveryStatus,
		deposit:
			canChangeDepositRequestStatus === undefined ? false : canChangeDepositRequestStatus,
		loan: canChangeCreditLoanStatus === undefined ? false : canChangeCreditLoanStatus,
		mail: true,
		educationcenter: true,
		reports: true,
		...OnlyReports,
		otpService: isRootUser,
		transactionalSmsProviders: canAccessTransactionalSmsProviders(
			canControlSmsProvider,
			isRootUser,
		),
		userCustomData: isRootUser,
		publicSettings: true,
	};
	const allReportsFalse = Object.values(OnlyReports).every((report) => report === false);
	if (allReportsFalse) {
		conditions.reports = false;
	}
	return conditions;
}
